import api from './axiosNew';

// ============================================
// SAP Sync API - matches backend: /api/sync
// Controller: SapSyncController.cs
// Service: SyncOrchestrationService.cs
// ============================================

/**
 * Trigger full manual sync with SAP (time entries + activity times)
 * POST /api/sync/trigger
 */
export const triggerSync = async () => {
  try {
    const response = await api.post('/api/sync/trigger');
    return response.data;
  } catch (error) {
    console.error('triggerSync error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Sync time entries to SAP via ManageEmployeeTimeIn
 * POST /api/sync/time-entries
 * Body (optional): { entryIds: ["guid1", "guid2"] }
 */
export const syncTimeEntries = async (entryIds = null) => {
  try {
    const response = await api.post('/api/sync/time-entries', { entryIds });
    return response.data;
  } catch (error) {
    console.error('syncTimeEntries error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Sync activity start/end times FROM SAP via QueryProductionLotISIIn
 * POST /api/sync/activity-times
 */
export const syncActivityTimes = async () => {
  try {
    const response = await api.post('/api/sync/activity-times');
    return response.data;
  } catch (error) {
    console.error('syncActivityTimes error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Get sync status (total/synced/pending/failed entries, connection, last sync)
 * GET /api/sync/status
 */
export const getSyncStatus = async () => {
  try {
    const response = await api.get('/api/sync/status');
    return response.data;
  } catch (error) {
    console.error('getSyncStatus error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Get sync history log
 * GET /api/sync/history?limit=20
 */
export const getSyncHistory = async (limit = 20) => {
  try {
    const response = await api.get('/api/sync/history', { params: { limit } });
    return response.data;
  } catch (error) {
    console.error('getSyncHistory error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Retry all failed sync items
 * POST /api/sync/retry-failed
 */
export const retryFailedSync = async () => {
  try {
    const response = await api.post('/api/sync/retry-failed');
    return response.data;
  } catch (error) {
    console.error('retryFailedSync error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Get all failed sync entries (TimeEntries + Activity Confirmations)
 * GET /api/sync/failed-entries
 * Backend scopes results automatically based on the JWT token.
 */
export const getFailedEntries = async () => {
  try {
    const response = await api.get('/api/sync/failed-entries');
    return response.data;
  } catch (error) {
    console.error('getFailedEntries error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Retry a single failed sync item
 * POST /api/sync/retry-single/{id}?type=TimeEntry|ActivityConfirmation
 */
export const retrySingleSync = async (id, type) => {
  try {
    const response = await api.post(`/api/sync/retry-single/${id}?type=${encodeURIComponent(type)}`);
    return response.data;
  } catch (error) {
    console.error('retrySingleSync error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Delete a failed sync entry (removes bad/half data)
 * DELETE /api/sync/failed/{id}?type=TimeEntry|ActivityConfirmation
 */
export const deleteFailedEntry = async (id, type) => {
  try {
    const response = await api.delete(`/api/sync/failed/${id}?type=${encodeURIComponent(type)}`);
    return response.data;
  } catch (error) {
    console.error('deleteFailedEntry error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};

/**
 * Get sync queue items (basic CRUD queue)
 * GET /api/sync-queue
 */
export const getSyncQueue = async () => {
  try {
    const response = await api.get('/api/sync-queue');
    return response.data;
  } catch (error) {
    console.error('getSyncQueue error:', error.response?.data || error.message);
    return { isSuccess: false, data: null, message: error.message };
  }
};
